module.exports = __webpack_public_path__ + "static/media/icon.c0900549.svg";